module.exports = __webpack_public_path__ + "img/1597.4e30357a.png";